import { useTranslation } from "react-i18next";
import { ShieldCheck, Sparkles, Landmark } from "lucide-react";

export function AboutPage() {
  const { t } = useTranslation();
  const values = [
    { key: "clinical", icon: Sparkles },
    { key: "trust", icon: ShieldCheck },
    { key: "culture", icon: Landmark },
  ] as const;

  return (
    <div className="container-app py-16 lg:py-20">
      <h1 className="text-4xl font-semibold text-charcoal-900">{t("about.title")}</h1>
      <p className="mt-4 max-w-2xl text-lg text-charcoal-600">{t("about.intro")}</p>

      <div className="mt-12 rounded-lg border border-charcoal-100 bg-white p-8 shadow-card">
        <h2 className="text-xl font-semibold text-charcoal-800">{t("about.missionTitle")}</h2>
        <p className="mt-2 text-charcoal-600">{t("about.missionBody")}</p>
      </div>

      <h2 className="mt-14 text-2xl font-semibold text-charcoal-900">{t("about.valuesTitle")}</h2>
      <div className="mt-6 grid gap-6 sm:grid-cols-3">
        {values.map((v) => (
          <div key={v.key} className="rounded-lg border border-charcoal-100 bg-white p-6 shadow-card">
            <v.icon className="h-6 w-6 text-primary-700" />
            <h3 className="mt-3 font-semibold text-charcoal-800">{t(`about.values.${v.key}.title`)}</h3>
            <p className="mt-1.5 text-sm text-charcoal-500">{t(`about.values.${v.key}.body`)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
